{
	"seo": {
		"title": "StudyHub — курс из ваших материалов, тема за темой",
		"description": "StudyHub собирает курс из ваших материалов или из открытых источников и ведёт каждую тему по трём шагам: разобраться, проверить себя, добрать.",
		"descriptionShort": "Курс из ваших материалов: каждая тема идёт по трём шагам — разобраться, проверить себя, добрать."
	},
	"header": {
		"login": "Войти",
		"signup": "Попробовать",
		"help": "Помощь",
		"navFeatures": "Возможности",
		"navHow": "Как работает",
		"navMethod": "Метод",
		"navPricing": "Тарифы",
		"navFaq": "FAQ"
	},
	"hero": {
		"eyebrow": "Учебный курс под вас",
		"title": "Освойте любой материал — до конца.",
		"lead": "StudyHub собирает курс из ваших материалов или из открытых источников, делит его на темы и доводит каждую до освоения по трём шагам.",
		"method": {
			"hint": "Каждая тема идёт по трём шагам"
		},
		"ctaPrimary": "Начать бесплатно",
		"ctaSecondary": "Как это работает",
		"checks": {
			"trial": "14 дней Plus в подарок",
			"noCard": "Без банковской карты"
		},
		"preview": {
			"title": "Лекция 12 — Клеточное дыхание",
			"status": "готово",
			"meta": "91 минута · готово 47 сек назад",
			"sectionTitle": "1. Этапы клеточного дыхания",
			"steps": {
				"s1": "Гликолиз — расщепление глюкозы в цитоплазме (2 ATP, 2 NADH)",
				"s2": "Цикл Кребса — окисление пирувата в матриксе митохондрии",
				"s3": "Электронно-транспортная цепь — синтез основной массы ATP"
			},
			"aiHint": "AI-подсказка: на экзаменах часто спрашивают про итоговый выход ATP (≈30–32). Я добавил это в карточку №7.",
			"source": "Источник · PDF, 14 стр.",
			"cards": {
				"counter": "Карточка 7 из 24",
				"frontLabel": "Вопрос",
				"front": "Сколько ATP даёт полное окисление одной молекулы глюкозы?",
				"backLabel": "Ответ",
				"back": "≈30–32 ATP (гликолиз + цикл Кребса + электронно-транспортная цепь)"
			},
			"quiz": {
				"counter": "Вопрос 3 из 15",
				"question": "Где происходит цикл Кребса?",
				"opt1": "В цитоплазме",
				"opt2": "В матриксе митохондрии",
				"opt3": "На рибосомах"
			},
			"podcast": {
				"title": "Аудио-резюме лекции",
				"host": "2 голоса · диалог",
				"elapsed": "3:12",
				"duration": "8:42"
			},
			"tutor": {
				"q": "Объясни разницу между гликолизом и циклом Кребса",
				"a": "Гликолиз идёт в цитоплазме без кислорода и даёт 2 ATP, а цикл Кребса — в матриксе митохондрии, окисляет пируват до CO₂ и питает электронно-транспортную цепь."
			}
		},
		"ctaPrimaryNoSale": "Начать"
	},
	"method": {
		"eyebrow": "Метод",
		"note": "Практическое тестирование · распределённое повторение",
		"title": "Почему именно эти три шага",
		"lead": "Перечитывать и подчёркивать — самые популярные и самые слабые способы учиться. Метод собран из двух техник, которые в обзорах получают высшую оценку.",
		"step1": {
			"body": "Материал становится опорой: конспект, аудио, схема, глоссарий. Шаг короткий — он готовит почву для проверки."
		},
		"step2": {
			"body": "Карточки и тест на извлечение из памяти. Перед ответом вы отмечаете, насколько уверены, — это меняет разбор."
		},
		"step3": {
			"body": "Тест показывает, где именно пробел. Дальше система работает с ним, а не с темой целиком."
		},
		"link": "Исследования и ссылки — на странице «Метод»",
		"figure": {
			"title": "Что остаётся в памяти",
			"legendRoute": "Маршрут темы",
			"legendReread": "Перечитывание",
			"delta": "разница — то, что осталось",
			"axisRepeat": "повторы по расписанию",
			"alt": "Схема: при маршруте из трёх шагов в памяти остаётся заметно больше, чем при перечитывании"
		}
	},
	"course": {
		"eyebrow": "Курс",
		"note": "Материалы · интернет · каталог",
		"title": "Курс появляется из чего угодно",
		"lead": "Загрузите материалы, соберите курс по теме из открытых источников или возьмите готовую программу. Курс делится на темы, тема — на три шага.",
		"paths": {
			"own": {
				"title": "Из ваших материалов",
				"body": "PDF, документы, таблицы, презентации, фото, аудио и видео, YouTube, веб-страницы. До 5 ГБ на Plus.",
				"bodyNoSale": "PDF, документы, таблицы, презентации, фото, аудио и видео, YouTube, веб-страницы."
			},
			"web": {
				"title": "Из интернета",
				"body": "Опишите тему — StudyHub найдёт источники, соберёт из них программу и разложит её по темам."
			},
			"catalog": {
				"title": "Из каталога",
				"body": "Готовые программы: ЕГЭ, ОГЭ, SAT, AP, A-Level, GCSE, Abitur, Bac, ЕНТ, JEE, IELTS, TOEFL."
			}
		},
		"goal": "Скажите, зачем учитесь: «сдать ЕГЭ на 80+» станет целью курса — под неё настраиваются глубина, примеры и вопросы.",
		"sources": "Источники видны в курсе всегда: конспекты и ответы репетитора ссылаются на конкретный фрагмент.",
		"figure": {
			"alt": "Схема: материалы, интернет и каталог сходятся в один курс, курс делится на темы"
		}
	},
	"topicRoute": {
		"eyebrow": "Маршрут темы",
		"note": "Разобраться · проверить себя · добрать",
		"title": "Как проходит одна тема",
		"lead": "Шаги открываются последовательно. Пока тема не проверена, третий шаг заперт — и это важнее, чем кажется.",
		"checkpoint": "Тема подтверждается контрольным тестом. Не хватило — ещё раунд по промахам; «Завершить» доступна всегда.",
		"step1": {
			"items": [
				"Конспект темы",
				"Подкаст, лекция или краткий пересказ",
				"Глоссарий темы",
				"Интеллект-карта",
				"Инфографика",
				"Своя заметка"
			]
		},
		"step2": {
			"items": [
				"Карточки шести типов с интервальным повторением",
				"Тест семи типов вопросов",
				"Оценка уверенности перед ответом",
				"Разбор каждого ответа сразу после теста"
			]
		},
		"step3": {
			"items": [
				"Пробелы, найденные тестом",
				"Голосовой репетитор 15-минутной сессией",
				"Репетитор в чате",
				"Разбор с персонажем",
				"Ещё один тест по пробелам",
				"Карточки по пробелам",
				"Заметка по пробелам",
				"Перечитать раздел",
				"Контрольный тест"
			]
		}
	},
	"tutor": {
		"eyebrow": "Репетитор",
		"note": "Контекст экрана · ссылки на источник",
		"title": "Репетитор знает, на каком вы экране",
		"lead": "Он видит текущую тему и ваши материалы, показывает ход рассуждения и отвечает со ссылками на источник — а не «в целом по интернету».",
		"facts": {
			"everywhere": "Рядом на любом экране — в боковой панели, и на отдельном, если нужен большой разговор.",
			"voice": "Голосовая сессия по плану урока — или точечная, по одному пробелу.",
			"build": "Может тут же собрать тест, карточки, схему или аудио по разговору."
		}
	},
	"characters": {
		"eyebrow": "Персонажи",
		"note": "Другой собеседник · те же источники",
		"title": "Разобрать тему с тем, кого хочется слушать",
		"lead": "Тот же материал, другой собеседник. Персонаж ведёт разбор по вашим источникам — это смена способа объяснять, а не оформления.",
		"examples": {
			"wizard": "Обсудить квантовую механику с волшебником",
			"cartoon": "Разобрать химию с героем любимого мультсериала",
			"philosopher": "Спросить про микропроцессоры у античного философа",
			"detective": "Пройти историю с книжным сыщиком"
		},
		"catalog": "Готовые персонажи — в каталоге; он общий с CharacterHub и подключается к вашему аккаунту.",
		"disclaimer": "Персонаж меняет манеру объяснения. Фактическая часть остаётся привязанной к вашим источникам."
	},
	"rhythm": {
		"eyebrow": "Ритм",
		"note": "План · календарь · напоминания",
		"title": "Учёба идёт по расписанию, а не по настроению",
		"lead": "Скажите, сколько минут в день готовы уделять, — система разложит темы, повторы и дедлайны по дням. Пропустили — пересоберёт.",
		"facts": {
			"budget": "Один план на все курсы, общий дневной бюджет",
			"calendar": "Календарь: занятия, повторы, дедлайны",
			"reminders": "Напоминания в вашем часовом поясе",
			"recording": "Запись лекции идёт с заблокированным экраном"
		},
		"figure": {
			"alt": "Схема: недельная раскладка занятий и повторов внутри дневной нормы минут"
		}
	},
	"toolbox": {
		"eyebrow": "Всё, что внутри",
		"note": "Сгруппировано так же, как в интерфейсе",
		"title": "Всё, что внутри",
		"lead": "Инструменты сгруппированы так же, как в интерфейсе, — по тому, что вы делаете.",
		"groups": {
			"library": "Библиотека и источники",
			"libraryHint": "Материалы, папки, поиск, глоссарий, запись лекций"
		}
	},
	"demo": {
		"frame": {
			"topicRoute": "Маршрут темы",
			"course": "Курс",
			"tutor": "Репетитор",
			"characters": "Разбор с персонажем",
			"step1": "Шаг 1 · разобраться",
			"step2": "Шаг 2 · проверить себя",
			"step3": "Шаг 3 · добрать"
		},
		"topic": {
			"title": "Цикл Кребса",
			"meta": "Биохимия · тема 3 из 6 · 18 мин",
			"progress": "2/3",
			"step1": {
				"sub": "Конспект · аудио · глоссарий темы",
				"state": "готово"
			},
			"step2": {
				"sub": "Карточки и тест со шкалой уверенности",
				"state": "8/12"
			},
			"step3": {
				"sub": "Откроется после проверки — по вашим промахам",
				"state": "заперто"
			}
		},
		"citation": "Гл. 4 · с. 142",
		"citationNote": "Каждый ответ — со ссылкой на ваш источник",
		"course": {
			"title": "Биохимия · клеточное дыхание",
			"meta": "6 тем · освоено 2 из 6",
			"topics": [
				"Гликолиз",
				"Окислительное декарбоксилирование",
				"Цикл Кребса",
				"Дыхательная цепь",
				"Окислительное фосфорилирование",
				"Регуляция и патологии"
			]
		},
		"confidence": {
			"label": "Насколько уверены?",
			"unsure": "Не уверен",
			"doubt": "Сомневаюсь",
			"sure": "Уверен"
		},
		"gap": {
			"title": "Пробел из теста",
			"body": "Путаете субстратное фосфорилирование с окислительным",
			"tools": [
				"Голосом · 15 мин",
				"Карточки по пробелам",
				"Ещё один тест"
			]
		},
		"tutor": {
			"context": "Тема: Цикл Кребса",
			"thinking": "Сверяю с вашим конспектом",
			"q": "Почему цикл Кребса не идёт без кислорода?",
			"a": "Сам цикл кислород не потребляет. Он останавливается косвенно: без кислорода дыхательная цепь не окисляет NADH обратно в NAD⁺, и цикл встаёт без переносчиков."
		},
		"characters": {
			"role": "Разбирает по вашим источникам",
			"q": "Объясни цикл Кребса как расследование",
			"a": "Итак, у нас пропали два атома углерода. Отследим их: ацетил-КоА входит в цикл, а на выходе мы находим две молекулы CO₂ — улики совпали."
		},
		"rhythm": {
			"days": [
				"Пн",
				"Вт",
				"Ср",
				"Чт",
				"Пт",
				"Сб",
				"Вс"
			],
			"norm": "Норма дня",
			"normValue": "45 из 60 мин",
			"today": "Сегодня",
			"legendLesson": "Занятие",
			"legendReview": "Повтор",
			"legendDeadline": "Дедлайн"
		}
	},
	"audiences": {
		"eyebrow": "Кому",
		"note": "Школа · университет · профессия",
		"title": "Один инструмент — три аудитории",
		"lead": "Школьник готовится к выпускным. Студент — к сессии. Профи — к сертификации. Одно пространство, разный контекст.",
		"tabs": {
			"school": "Школа",
			"university": "Университет",
			"pro": "Курсы и проф"
		},
		"tags": {
			"notes": "Конспект",
			"cards": "Карточки",
			"quiz": "Тест",
			"tutor": "Чат"
		},
		"school": {
			"headline": "Готовлюсь к выпускным экзаменам",
			"bullets": [
				"Запись урока с автотранскриптом и конспектом",
				"Распознавание рукописных конспектов по фото",
				"Чат с AI объясняет сложные темы на твоём уровне",
				"Шаблоны подготовки под систему обучения твоей страны"
			],
			"caseLabel": "Сценарий",
			"caseTitle": "Подготовка к выпускным по биологии",
			"caseBody": "8 школьных учебников и 3 курса с YouTube → конспекты, карточки на повторение и тест по всему материалу. AI помечает слабые места и сам подсказывает, что повторить сегодня."
		},
		"university": {
			"headline": "Готовлюсь к сессии",
			"bullets": [
				"Запись лекции с автоконспектом",
				"Чат с AI знает весь твой курс, а не один файл",
				"Weak Spots после теста: что повторить перед экзаменом",
				"Учебный план по датам сессии — AI распределит нагрузку"
			],
			"caseLabel": "Сценарий",
			"caseTitle": "Подготовка к коллоквиуму",
			"caseBody": "12 лекций, 4 главы учебника, 2 статьи → глоссарий терминов, тесты на ключевые темы и аудио-резюме на дорогу. Готовый учебный пакет за один вечер."
		},
		"pro": {
			"headline": "Учусь параллельно с работой",
			"bullets": [
				"AWS, Google Cloud, профессиональные сертификации",
				"Аудио-резюме на пробежке и в дороге",
				"Чат с AI объясняет на нужной глубине",
				"Календарь подготовки — AI учитывает твои часы в неделю"
			],
			"caseLabel": "Сценарий",
			"caseTitle": "Подготовка к AWS Solutions Architect",
			"caseBody": "Официальная документация и видеокурсы → структурированные конспекты, тесты по разделам экзамена и голосовой репетитор для разбора сложных тем. По 30 минут в день."
		}
	},
	"pricing": {
		"eyebrow": "Тарифы",
		"note": "Free навсегда · Plus · Pro",
		"title": "Простые тарифы",
		"countryHint": "Free навсегда. Plus — для активной учёбы. Pro — для подготовки к экзаменам.",
		"popular": "Популярный",
		"viewAll": "Все возможности",
		"perMonth": "/мес",
		"free": {
			"name": "Free",
			"tagline": "Чтобы попробовать",
			"features": [
				"5 AI-генераций в день",
				"До 10 материалов, 100 МБ",
				"Конспекты, карточки, тесты",
				"Мобильное приложение + веб"
			]
		},
		"plus": {
			"name": "Plus",
			"tagline": "Для активной учёбы",
			"features": [
				"50 AI-генераций в день",
				"До 100 материалов, 5 ГБ",
				"Подкаст в два голоса",
				"Скачивание оригиналов файлов",
				"Deep Research: 5 прогонов в месяц"
			]
		},
		"pro": {
			"name": "Pro",
			"tagline": "Для экзаменов и сертификаций",
			"features": [
				"Безлимит AI-генераций",
				"20 ГБ библиотеки без ограничения по числу файлов",
				"Совместное обучение",
				"Deep Research: 20 прогонов в месяц",
				"Ранний доступ к обновлениям приложения"
			]
		}
	},
	"faq": {
		"eyebrow": "Вопросы",
		"note": "Метод · данные · тарифы",
		"title": "Частые вопросы",
		"items": {
			"method": {
				"q": "Почему именно эти три шага?",
				"a": "Порядок «разобраться → проверить себя → добрать» собран вокруг двух техник, которые в обзорах учебных методов получают высшую оценку полезности, — практического тестирования и распределённого повторения. Подробно, с источниками, — на странице «Метод»."
			},
			"ai": {
				"q": "Как работает AI?",
				"a": "Загруженные тобой материалы — основа всего: AI разбирает их и строит на них конспекты, карточки, тесты и ответы репетитора. Контекст живёт в рамках твоего аккаунта."
			},
			"dataResidency": {
				"q": "Что происходит с моими данными?",
				"a": "Материалы доступны только тебе и используются исключительно для того, чтобы помогать тебе учиться — генерировать конспекты, карточки, тесты и ответы репетитора по твоему материалу. Удаление аккаунта стирает всё безвозвратно через 30 дней — этот период можно отменить и вернуться."
			},
			"pricing": {
				"q": "Сколько стоит?",
				"a": "Free — навсегда: 5 AI-генераций в день, до 10 материалов. Plus ({plusPrice}/мес) поднимает лимит до 50 генераций в день и 5 ГБ библиотеки. Pro ({proPrice}/мес) снимает лимит на генерации."
			},
			"youtube": {
				"q": "Можно ли загружать видео с YouTube?",
				"a": "Да. Вставьте ссылку — StudyHub достанет транскрипт и соберёт по нему конспект, карточки и тест. Так же работает любая веб-страница; аудио- и видеофайлы можно загрузить напрямую."
			},
			"mobile": {
				"q": "Работает на мобильном?",
				"a": "Да. Нативные приложения для iOS и Android, та же база что в web — синхронизация офлайн. Запись лекций продолжает работать с заблокированным экраном."
			},
			"errors": {
				"q": "Что если AI ошибётся?",
				"a": "Ответы репетитора и конспекты показывают источник — конкретный фрагмент вашего материала. Видно, откуда взято, и это проверяется в один клик."
			},
			"cancel": {
				"q": "Можно ли отменить подписку?",
				"a": "Да, в любой момент. Доступ к Plus или Pro сохраняется до конца оплаченного периода — без скрытых платежей и удержаний."
			}
		},
		"contact": {
			"title": "Остались вопросы?",
			"lead": "Напишите нам — мы отвечаем лично, обычно в течение одного рабочего дня.",
			"emailLabel": "Электронная почта",
			"telegramLabel": "Поддержка в Telegram",
			"legalNav": "Юридические документы"
		},
		"noteNoSale": "Метод · данные · поддержка"
	},
	"finalCta": {
		"title": "Готов попробовать?",
		"lead": "14 дней Plus в подарок, без банковской карты.",
		"signup": "Начать бесплатно",
		"sso": "У меня уже есть аккаунт",
		"leadNoSale": "Загрузите первый материал и посмотрите, как работает метод."
	},
	"footer": {
		"tagline": "Твой второй мозг для учёбы — конспекты, карточки, тесты, чат и голосовой репетитор в одном приложении.",
		"product": "Продукт",
		"company": "Компания",
		"legal": "Правовое",
		"rights": "© 2026 StudyHub",
		"links": {
			"features": "Возможности",
			"pricing": "Тарифы",
			"mobile": "Мобильное приложение",
			"about": "О проекте",
			"support": "Помощь",
			"privacy": "Политика конфиденциальности",
			"terms": "Пользовательское соглашение",
			"ai": "AI-дисклеймер",
			"cookie": "Политика Cookie"
		}
	},
	"ecosystem": {
		"title": "Экосистема ЦМО",
		"subtitle": "StudyHub — часть образовательной экосистемы Центра Международного Обмена",
		"appStoreAlt": "Скачать в App Store",
		"googlePlayAlt": "Доступно в Google Play",
		"exchange": "Портал Exchange",
		"exchangeDesc": "Общайтесь, читайте новости, участвуйте в программах и конкурсах",
		"courses": "Платформа курсов",
		"coursesDesc": "Проходите обучение онлайн уникальным специальностям",
		"hero": "IEC Hero",
		"heroDesc": "Общайтесь с AI-персонажами и создавайте своих",
		"travel": "TravelHub",
		"travelDesc": "Находите уникальные форматы путешествий, выгодно",
		"career": "IEC Career Lab",
		"careerDesc": "Находите уникальные программы стажировок",
		"programs": "Международные программы обмена",
		"programsDesc": "Работайте и обучайтесь за рубежом по программам обмена",
		"prev": "Предыдущие сервисы",
		"next": "Следующие сервисы"
	}
}
